"use client";

import { useState } from "react";
import { sendGAEvent } from "@next/third-parties/google";

/** 코드 스니펫 옆 클립보드 복사 버튼(2026-09-16, 테스트 랜딩페이지) — 서버 컴포넌트인 페이지에서
 * 바로 못 쓰는 상호작용(navigator.clipboard)만 클라이언트 컴포넌트로 분리했다.
 * gaEventName을 주면 복사 성공 시 GA4 커스텀 이벤트를 전송한다(대표 지시 2026-09-25,
 * 랜딩 최상단 npx 복사 버튼 클릭률 추적) — 넘기지 않으면 기존과 동일하게 GA 미전송. */
export default function CopyButton({
  text,
  className,
  gaEventName,
}: {
  text: string;
  className?: string;
  gaEventName?: string;
}) {
  const [copied, setCopied] = useState(false);

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      if (gaEventName) sendGAEvent("event", gaEventName, { text });
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // 클립보드 권한이 없는 환경(일부 인앱 브라우저 등) — 조용히 무시, 사용자가 직접 선택해서 복사하면 됨.
    }
  }

  return (
    <button
      type="button"
      onClick={handleCopy}
      aria-label="Copy to clipboard"
      className={
        className ??
        "shrink-0 rounded-md border border-zinc-700 px-2 py-1 text-xs text-zinc-300 transition hover:bg-zinc-800 hover:text-white"
      }
    >
      {copied ? "Copied!" : "Copy"}
    </button>
  );
}
